module.exports = __webpack_public_path__ + "img/8_pc.1a3fadff.gif";